export const getDiscountsState = (state) => state.discounts;

export const getDiscountState = (state) => state.discount;
